<div class="wrapper">
    <div id="formContent">
      <h2 class="title"> GRT Branding Monitoring </h2>
        <div class="fadeIn first">
            <img src="assets/grt.svg" id="icon" alt="" />
        </div>
        <div class="" *ngIf="nSubModule==1">
            <div [formGroup]="login_form">
                <div class="col-md-12">
                    <div class="form-group">
                        <input type="text" id="login" formControlName="email" class="fadeIn second"  placeholder="Email" autocomplete="on">
                    </div>
                    <div class="form-group">
                        <input type="password" id="password" formControlName="password"class="fadeIn third" name="login" placeholder="Password" autocomplete="on">
                    </div>
                    
                </div>
    
                <input type="submit" class="fadeIn fourth mb-0" (click)="submitForm()" value="Log In">
                <div class="m-4 d-flex justify-content-center">
                    <label class=" p-0" for="forgot_password" data-content="Forgot Password" (click)="forgotPassword()">Forgot Password ?</label>
                </div>
                <!-- <br> {{ login_form.getRawValue() | json }} -->
                <div id="formFooter">
                    <div class="row m-0 p-0">
                        <input type="checkbox" id="todo" formControlName="remember" name="todo" value="todo" class="mt-2">
                        <label class="mp-0" for="todo" data-content="Remember me">Remember me</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="" *ngIf="nSubModule==2">
            <div [formGroup]="pwdreset_form">
               
                <h4>Reset your Password</h4>
                <!-- <p class="p-3">We'll email you the password or instruction how to reset it</p> -->
                <div class="col-md-12">
                    <div class="form-group">
                        <input type="password" id="password" formControlName="password" class="fadeIn second" name="password" placeholder="New Password" autocomplete="on">

                    </div>

                    <div class="form-group">
                        <input type="password" id="password" formControlName="c_password" class="fadeIn second" name="password" placeholder="Confirm New Password" autocomplete="on">

                    </div>
                                     
                </div>
                <input type="submit" class="fadeIn fourth mb-0" (click)="updatepassword()" value="Reset Password">
                <div class="d-flex justify-content-center">
                    <label class="m-4 p-0" for="back_to_Login" data-content="Back to Signin" (click)="back_to_Login()">Back to Signin</label>
                </div>
            
            </div>
        </div>


        <div class="" *ngIf="nSubModule==3">
            <div [formGroup]="pwdforgot_form">
            
                <h4>Forgot Password</h4>
                <p class="p-3">We'll email you the password or instruction how to reset it</p>
                <div class="col-md-12">
                    <div class="form-group">
                        <input type="text" id="login" formControlName="email" class="fadeIn second"  placeholder="Email" autocomplete="on">
                    </div> 
                </div>
                <input type="submit" class="fadeIn fourth mb-0" (click)="clickforgotpassword()" value="Send Password">
                <div class="d-flex justify-content-center">
                    <label class="m-4 p-0" for="back_to_Login" data-content="Back to Signin" (click)="back_to_Login()">Back to Signin</label>
                </div>
            
            </div>
        </div>
      
    </div>
  </div>

  <ng-template #success let-modal class="mp-0">
    <div class="p-2">
      <div class="modal-body text-center">
        <h4>Email sent successfully</h4>
        <p>Thanks</p>
        <button class="btn btn-okay" (click)="modal.dismiss('Cross click')"><span>Ok</span></button>
      </div>
    </div> 
  </ng-template>